var _style, _g, _path, _polygon, _path2, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUnknow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.4 44.8",
    style: {
      enableBackground: "new 0 0 34.4 44.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D8D8D8;}\n\t.st2{fill:#7C7C7C;}\n\t.st3{fill:none;}\n\t.st4{font-family:'OpenSans-SemiBold';}\n\t.st5{font-size:14px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.7,44.3c-0.1,0-0.2-0.1-0.2-0.2V0.7c0-0.1,0.1-0.2,0.2-0.2h33c0.1,0,0.2,0.1,0.2,0.2v43.4 c0,0.1-0.1,0.2-0.2,0.2H0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,1v42.8H1V1H33.4 M33.7,0h-33C0.3,0,0,0.3,0,0.7v43.4c0,0.4,0.3,0.7,0.7,0.7h33c0.4,0,0.7-0.3,0.7-0.7 V0.7C34.4,0.3,34.1,0,33.7,0L33.7,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,44.8h-32c-0.6,0-1.2-0.5-1.2-1.2V31.2h34.4v12.4C34.4,44.3,33.9,44.8,33.2,44.8L33.2,44.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.1,10.6 10.1,24.6 24.3,24.6 24.3,5.8 12.5,5.8 10.1,7.9 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.3,10c-0.2,0-0.3,0.1-0.3,0.4v11.3c0,0.1,0.1,0.2,0.3,0.2h7c0.1,0,0.3-0.1,0.3-0.2V10.4 c0-0.3-0.1-0.4-0.3-0.4H14.3z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 14.0001 20.6403)",
    className: "st0 st4 st5"
  }, "?")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUnknow);
export default __webpack_public_path__ + "static/media/file-unknow.884e1c73d4cf68d0bc746e815b42aa80.svg";
export { ForwardRef as ReactComponent };